
import { useState, useEffect } from 'react';
import { testSupabaseConnection } from '@/lib/api';
import { toast } from 'sonner';

export const useIndexPageState = () => {
  const [connectionStatus, setConnectionStatus] = useState<'loading' | 'connected' | 'disconnected'>('loading');
  
  useEffect(() => {
    const checkConnection = async () => {
      const isConnected = await testSupabaseConnection();
      setConnectionStatus(isConnected ? 'connected' : 'disconnected');
      
      if (!isConnected) {
        toast.error('Unable to connect to database', {
          description: 'Please check your network connection and try again.',
          duration: 5000,
        });
      }
    };
    
    // Defer connection check to after first paint for faster FCP
    if ('requestIdleCallback' in window) {
      requestIdleCallback(() => checkConnection(), { timeout: 2000 });
    } else {
      // Fallback for Safari - delay 500ms after first paint
      setTimeout(checkConnection, 500);
    }
  }, []);

  return {
    connectionStatus
  };
};
